(function($, Cobalt, undefined) {
    function allowNewFieldToBeAdded(fieldList) {
        ///<summary>Returns false if a new empty field is trying to be added while empty fields exist.</summary>
        var totalInputs = fieldList.querySelectorAll("input").length;
        var inputs = [].slice.call(fieldList.querySelectorAll("input[type=text]"));

        function containsValue(input) {
            // when a value is added the value attribute doesn't change but a "valid" class is added.
            return input.getAttribute('value').length > 0 || input.classList.contains("valid");
        }

        var inputsWithValue = inputs.filter(containsValue);

        if (totalInputs > 0 && totalInputs > inputsWithValue.length) {
            return false;
        }

        return true;
    }

    Cobalt.FieldLists = {
        initialize: function ($parent) {
            $parent.find(".field-list").each(function () {
                var $fieldList = $(this);
                var $exampleField = $fieldList.find(".example-form-field");
                $exampleField.removeClass("example-form-field");
                var name = $exampleField.find("input").attr("name");
                if (!name) {
                    name = $exampleField.find("select").attr("name");
                }
                var match = /^(.*)-(\d+)$/.exec(name);
                if (match !== null) {
                    var $field = $exampleField.clone();
                    $field.find("input").removeAttr("id");
                    $exampleField.remove();

                    var baseName = match[1];

                    var calculateNextIndex = function () {
                        for (var i = 1; ; i++) {
                            if ($fieldList.find("[name=" + baseName + "-" + i + "]").length == 0) {
                                return i;
                            }
                        }
                    };

                    var remapNames = function () {
                        var index = 0;
                        $fieldList.find(".form-field").each(function () {
                            var $field = $(this);
                            index++;
                            $field.find("input")
                                .each(function () {
                                    var match = /^(.*)-(\d+)$/.exec($(this).attr("name"));
                                    if (match !== null) {
                                        $(this).attr("name", match[1] + "-" + index);
                                    }
                                });
                        });
                    };
                    var addRemoveLink = function ($field) {
                        var $removeLink = $("<a />")
                            .attr("href", "#")
                            .addClass("remove-link")
                            .click(function () {
                                removeAssociatedHiddenField($field);
                                $field.remove();
                                remapNames();
                                return false;
                            });
                        $field.append($removeLink);
                    };

                    var removeAssociatedHiddenField = function ($field) {
                        var $input = $field.find("input");
                        if ($input.length) {
                            var autoHideAttr = $input.data("autoHide");
                            if (autoHideAttr) {
                                var $hiddenField = $("[data-auto-hide='" + autoHideAttr + "'][type='hidden']").remove();
                            }                           
                        }
                    }

                    var $link = $("<a />")
                        .attr("href", "#")
                        .text($fieldList.data('add-label') || "New entry")
                        .addClass("field-list-new-entry")
                        .click(function () {
                           if (!allowNewFieldToBeAdded($fieldList[0])) {
                               return false;
                           }

                            var $clone = $field.clone();
                            var index = calculateNextIndex();
                            $clone.find("input")
                                .each(function () {
                                    var match = /^(.*)-(\d+)$/.exec($(this).attr("name"));
                                    if (match !== null) {
                                        $(this).attr("name", match[1] + "-" + index);
                                    }
                                });
                            $link.before($clone);

                            if ($fieldList.data("render-remove-link") === "True")
                                addRemoveLink($clone);

                            Cobalt.triggerHtmlInsert($clone);
                            return false;
                        });

                    if ($fieldList.data("hide-add-link") === "True") {
                        $link.hide();
                    }

                    $fieldList.append($link);

                    if ($fieldList.data("render-remove-link") === "True") {
                        $fieldList.find(".form-field").each(function () {
                            addRemoveLink($(this));
                        });
                    }

                    $fieldList.sortable({
                        containment: 'parent',
                        handle: '.sort-gripper'
                    }).bind('sortstop', function (event, ui) {
                        setTimeout(remapNames, 1);
                    });
                } else {
                    $exampleField.remove();
                }
            });
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.FieldLists.js